import { Placeholder } from '@kl/components-v6';
import styled from 'styled-components';

export const StyledPlaceholder = styled(Placeholder)`
    flex-flow: column;
`;
